import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import useAgenda from '../../hooks/useAgenda';
import InserirEvento from '../../components/agenda/InserirEvento';
import MessageModal from '../../components/modals/MessageModal';
import Spinner from '../../components/common/Spinner';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import EventList from '../../components/agenda/EventList';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

function AgendaPage() {
  const {
    eventos,
    setEventos,
    pacientes,
    novoEvento,
    setNovoEvento,
    error,
    isModalOpen,
    eventoToRemove,
    handleInputChange,
    handlePacienteSelect,
    handleRemoveClick,
    handleConfirmRemove,
    handleCancelRemove,
    adicionarEvento,
    handleEditSave,
    fetchEventsFromFirebase,
  } = useAgenda();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEvents = async () => {
      await fetchEventsFromFirebase();
      setLoading(false);
    };
    loadEvents();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  // Esta função será chamada quando um evento for editado
  const handleEventEditSave = (updatedEvent) => {
    setEventos((prevEventos) =>
      prevEventos.map((evento) =>
        evento.id === updatedEvent.id ? updatedEvent : evento
      )
    );
    toast.success('Evento atualizado com sucesso!');
  };

  const handleEventDrop = async (eventDropInfo) => {
    const updatedEvent = {
      id: eventDropInfo.event.id,
      data: eventDropInfo.event.start.toISOString().split('T')[0],
      hora: eventDropInfo.event.start.toTimeString().split(' ')[0],
    };

    try {
      const eventDocRef = doc(db, 'agenda', updatedEvent.id);
      await updateDoc(eventDocRef, {
        data: updatedEvent.data,
        hora: updatedEvent.hora,
      });

      // Atualize o estado local para refletir a mudança imediatamente
      setEventos((prevEventos) =>
        prevEventos.map((evento) =>
          evento.id === updatedEvent.id
            ? { ...evento, data: updatedEvent.data, hora: updatedEvent.hora }
            : evento
        )
      );

      toast.success('Evento atualizado com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar o evento no Firebase.');
      console.error('Erro ao atualizar o evento no Firebase:', error);
    }
  };

  const handleEventClick = (eventClickInfo) => {
    const clickedEvent = {
      id: eventClickInfo.event.id,
      descricao: eventClickInfo.event.extendedProps.description,
      data: eventClickInfo.event.start.toISOString().split('T')[0],
      hora: eventClickInfo.event.start.toTimeString().split(' ')[0],
    };
    handleRemoveClick(clickedEvent);
  };

  return (
    <Layout>
      <EventList
        eventos={eventos}
        onRemoveClick={handleRemoveClick}
        onEditSave={handleEventEditSave} // Use o novo handle para atualizar o estado local
      />
      <ToastContainer />
      <h2 className="text-3xl font-bold mb-8">Agenda</h2>
      <section className="agenda-page overflow-y-auto p-6 bg-gray-50 rounded-lg shadow-lg space-y-10">
        {error && (
          <div role="alert" className="text-red-600 mb-6" aria-live="assertive">
            {error}
          </div>
        )}
        {/* FullCalendar */}
        <div className="mb-10">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay',
            }}
            events={eventos.map((evento) => ({
              id: evento.id,
              title: evento.tipo,
              start: `${evento.data}T${evento.hora}`,
              end: `${evento.data}T${evento.hora}`,
              description: evento.descricao,
            }))}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            eventTimeFormat={{
              hour: '2-digit',
              minute: '2-digit',
              meridiem: false,
            }}
            locales={[ptBrLocale]}
            locale="pt-br"
            height="auto"
            className="fullcalendar-tailwind"
            eventDrop={handleEventDrop}
            eventClick={handleEventClick}
          />
        </div>

        {/* Formulário para adicionar evento */}
        <section className="adicionar-evento mb-6">
          <h3 className="text-xl font-semibold mb-4">Adicionar Evento</h3>
          <InserirEvento
            pacientes={pacientes}
            novoEvento={novoEvento}
            onInputChange={handleInputChange}
            onPacienteSelect={handlePacienteSelect}
            onAdicionarEvento={adicionarEvento}
          />
        </section>
      </section>

      <MessageModal
        isOpen={isModalOpen}
        onClose={handleCancelRemove}
        onConfirm={handleConfirmRemove}
        title="Confirmação de Remoção"
        message={`Tem certeza que deseja remover o evento: ${eventoToRemove?.descricao || 'Evento indefinido'}?`}
        ariaLabel="Modal de confirmação para remover evento"
      />
    </Layout>
  );
}

export default AgendaPage;
